module.exports = __webpack_public_path__ + "img/wz-7-4-5.a89e1cc7.jpg";